export default class Modal {
  constructor(element) {
    this.element = element;
    this.boutonsModale = this.element.querySelectorAll('.doodle-plein-ecran');
    this.modale = document.querySelector('.modale');
    this.boutonCloseModale = document.querySelector('.close-modale');
    this.options = {};

    this.init();
  }

  init() {
    // Boucle for pour ajouter un Event Listener à chaque bouton qui ouvre la fenêtre modale.
    for (let i = 0; i < this.boutonsModale.length; i++) {
      const boutonModale = this.boutonsModale[i];
      boutonModale.addEventListener('click', this.openModale.bind(this));
    }

    this.boutonCloseModale.addEventListener(
      'click',
      this.closeModale.bind(this)
    );

    document.addEventListener('keydown', this.escapeModale.bind(this));
  }

  // Fonction qui ouvre la modale en récupérant l'image sur lequel on a cliqué avec le bouton plein-écran pour l'insérer dans la fenêtre modale.
  openModale(element) {
    const container = element.currentTarget.closest('.container-img-modale');
    const imgModale = container.querySelector('.img-modale');

    document.body.classList.add('no-scroll');

    if (window.ScrollSmoother) {
      const smoother = ScrollSmoother.get();
      if (smoother) smoother.paused(true); 
    }

    const wrapper = document.createElement('div');
    const chemin = imgModale.getAttribute('src');
    const cheminTexte = imgModale.getAttribute('alt');
    const image = document.createElement('img');
    const texte = document.createElement('p');

    wrapper.classList.add('zoom-wrapper');
    texte.classList.add('texte-modale');
    image.setAttribute('src', chemin);
    texte.innerText = cheminTexte;
    image.classList.add('zoom');

    wrapper.appendChild(image);
    wrapper.appendChild(texte);

    this.modale.appendChild(wrapper);
    this.modale.classList.add('visible');
  }

  // Fonction pour fermer la fenêtre modale.
  closeModale() {
    this.modale.removeChild(this.modale.querySelector('.zoom-wrapper'));
    this.modale.classList.remove('visible');
    document.body.classList.remove('no-scroll');

    if (window.ScrollSmoother) {
      const smoother = ScrollSmoother.get();
      if (smoother) smoother.paused(false);
    }
  }

  escapeModale(element) {
    if (element.key == 'Escape' && this.modale.classList.contains('visible')) {
      this.closeModale();
    }
  }
}
